import './styles.scss';
import { useState } from 'react';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { collection, setDoc, doc, query, limit } from 'firebase/firestore';
import slug from 'slug'

export default function AddGroveSlugs(props) {
  const firestore = useFirestore()
  const grovesCollection = collection(firestore, 'groves')
  const grovesQuery = query(grovesCollection, limit(3))

  const { data: groves, status } = useFirestoreCollectionData(grovesQuery, {idField: 'id'})

  console.log(status, groves)
  const [groveProgress, setGroveProgress] = useState(null)
  const addSlugs = async () => {
    setGroveProgress({completed: 0, total: groves.length})
    for await (const grove of groves) {

      const groveSlug = slug(grove.name)
      const groveDoc = doc(firestore, 'groves', grove.id)
      await setDoc(groveDoc, {slug: groveSlug}, {merge: true})
      setGroveProgress(d => ({completed: d.completed + 1, total: groves.length}))
    }
  }
  return (
    <div>
      <h1>Add Grove Slugs</h1>
      {groveProgress && <div>{groveProgress.completed} of {groveProgress.total}</div>}
      {groves ? <button onClick={addSlugs} >Add Slugs</button> : null}

      <ul>
        {groves ? groves.map(grove => (
          <li key={grove.id}>
            {grove.name} - {grove.slug}
          </li>
        )) : null}
      </ul>
    </div>
  )
}